import SeoTitle from '@/components/SeoTitle';
import PageJsonLd from './components/PageJsonLd';
import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import WhatIsDelegation from './components/WhatIsDelegation';
import WhyManagersCantDelegate from './components/WhyManagersCantDelegate';
import MicromanagementVsControl from './components/MicromanagementVsControl';
import HowToSetTasks from './components/HowToSetTasks';
import TaskSettingMistakes from './components/TaskSettingMistakes';
import DelegationLevels from './components/DelegationLevels';
import WhoAndWhatToDelegate from './components/WhoAndWhatToDelegate';
import WhenDelegationFails from './components/WhenDelegationFails';
import ExecutionControl from './components/ExecutionControl';
import FeedbackInDelegation from './components/FeedbackInDelegation';
import WhenManagerNeedsDelegationTraining from './components/WhenManagerNeedsDelegationTraining';
import CompanyResults from './components/CompanyResults';
import HowTrainingWorks from './components/HowTrainingWorks';
import WhyProgramsWork from './components/WhyProgramsWork';
import FormatsSection from './components/FormatsSection';
import AboutTrainer from './components/AboutTrainer';
import FAQSection from './components/FAQSection';
import ReadNextSection from './components/ReadNextSection';
import FinalCTA from './components/FinalCTA';
import Footer from '@/components/feature/Footer';

const navLinks = [
  { label: 'Навыки', target: 'skills' },
  { label: 'Программа', target: 'process' },
  { label: 'Результаты', target: 'results' },
  { label: 'FAQ', target: 'faq' },
];

export default function DelegationTrainingPage() {
  return (
    <>
      
      <SeoTitle title="Делегирование и постановка задач | Business Training" />
      <PageJsonLd />

      <div className="min-h-screen bg-white font-['Inter']">
        <Navbar
          links={navLinks}
          ctaLabel="Заказать тренинг"
          ctaTarget="contact"
        />
        <HeroSection />
        <WhatIsDelegation />
        <WhyManagersCantDelegate />
        <MicromanagementVsControl />

        <div id="skills">
          <HowToSetTasks />
        </div>

        <TaskSettingMistakes />
        <DelegationLevels />
        <WhoAndWhatToDelegate />
        <WhenDelegationFails />
        <ExecutionControl />
        <FeedbackInDelegation />
        <WhenManagerNeedsDelegationTraining />

        <div id="results">
          <CompanyResults />
        </div>

        <div id="process">
          <HowTrainingWorks />
        </div>

        <WhyProgramsWork />
        <FormatsSection />
        <AboutTrainer />
        <FAQSection />
        <ReadNextSection />
        <FinalCTA />
        <Footer />
      </div>
    </>
  );
}